export default __webpack_public_path__ + "static/media/Group 58.dea12f42.svg";